import React from "react";
import { Col, Row } from "antd";
import Label from "../Label/Label";
import { label, translateRegistryOnView } from "../../libs/utils";

const CardField = (props) => {
  const { data, val, span = 8, schema, icon, entity } = props;

  return (
    <>
      {!!data[val] && (typeof data[val] === "number" || data[val].length > 0) && (
        <Col span={span} className="mb-3">
          <Row>
            {icon && icon}
            <Label value={label(schema, val, entity)} />
          </Row>
          {translateRegistryOnView(data[val], val, true)
            ? translateRegistryOnView(data[val], val, true)
            : data[val]}
        </Col>
      )}
    </>
  );
};

export default CardField;
